import { useTheme } from '@material-ui/styles';
import type { Theme } from '@bizzabo/design-system';
import { Select } from '@bizzabo/design-system';

const SchedulingPreferencesSelect = props => {
    const theme = useTheme<Theme>();
    return (
        <Select
            {...props}
            isSearchable={false}
            menuPlacement="auto"
            styles={{
                singleValue: provided => ({
                    ...provided,
                    ...theme.typography.t71,
                    color: theme.customization.interactive.G50,
                }),
                placeholder: provided => ({
                    ...provided,
                    ...theme.typography.t71,
                    color: theme.customization.interactive.G50,
                }),
                dropdownIndicator: provided => ({
                    ...provided,
                    padding: '0 6px',
                }),
                menuPortal: provided => ({ ...provided, zIndex: 10003 }),
                menu: provided => ({
                    ...provided,
                    zIndex: 10003,
                    fontSize: 14,
                }),
            }}
        />
    );
};

export default SchedulingPreferencesSelect;
